import { Pill } from 'ui-components/components/pill';
import { WalmartSimplifiedShippingLogo } from './walmart-simplified-shipping-logo';

export const WalmartSimplifiedShippingTag = () => {
  return (
    <Pill
      color='#0071ce'
      label={
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', height: '12px' }}>
          <WalmartSimplifiedShippingLogo />
          Simplified Shipping
        </div>
      }
    />
  );
};
